import Button from 'js/components/elements/editors/mui/Button';
import { TextField } from 'new/elements/TextField';
import React, { useState } from 'react';
import FilePreviewDialog from './FilePreviewDialog';
import classes from './TestCustomProcessor.module.scss';

export default function FilePreview({ credentialId, path, onChange }) {
  const [isOpen, setIsOpen] = useState(false);

  const onInputChanged = (event) => {
    onChange(event.target.value);
  };

  const onPreview = () => {
    setIsOpen(true);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div
        className={`${classes.inputContainer} data-format-file-preview`}
        data-testid="custom-processor-file-preview-container"
      >
        <label htmlFor="custom-processor-file-path">File Path</label>
        <TextField
          id="custom-processor-file-path"
          value={path}
          fullWidth
          onChange={onInputChanged}
          placeholder="e.g., folder/preview.csv or preview.csv"
          data-testid="custom-processor-file-path"
        />
        <Button
          variant="outlined"
          color="primary"
          disabled={!path || !credentialId}
          onClick={onPreview}
          data-testid="custom-processor-file-preview-button"
        >
          Preview File
        </Button>
      </div>
      <FilePreviewDialog open={isOpen} onClose={onClose} credentialId={credentialId} path={path} />
    </>
  );
}
